import { UsersListPage } from './UsersListPage';

export function KycReviewPage() {
  return <UsersListPage pageTitle="KYC 审核" initialKycStatus="pending" kycReviewMode />;
}
